import React from 'react'
import { withStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import useQueuedSave from 'src/hooks/useQueuedSave'
import { patchCertificateAction } from 'src/reducers/certificate/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { Toggle } from 'src/components/app-ui'
import CertificationHeader from '../certification-header'
import styles from './styles'

/** Certification on/off switch once a certificate exists. */
const IsActiveCertificate = ({ classes }) => {
  const dispatch = useDispatch()
  const certificate = useSelector(state => state.certificate.certificate)

  // Instant-save, so quick repeated clicks queue up instead of being lost.
  const [isActive, setIsActive] = useQueuedSave(
    Boolean(certificate.isActive),
    value =>
      new Promise((resolve, reject) => {
        const content = new PatchData(
          new PatchContent(value, 'isActive', PatchData.OPERATION_REPLACE),
          certificate.id,
        )
        dispatch(patchCertificateAction(content, resolve, reject))
      }),
  )

  return (
    <>
      <CertificationHeader
        toggle={<Toggle checked={isActive} onChange={setIsActive} />}
      />
      {/* Dims the settings below while certification is off. */}
      {!isActive && <div className={classes.certicationLock} />}
    </>
  )
}

export default withStyles(styles)(IsActiveCertificate)
